export async function runPasses<TPass, TResult>({
  passes,
  parallel,
  runPass,
  onPassComplete,
}: {
  passes: TPass[];
  parallel: boolean;
  runPass: (pass: TPass) => Promise<TResult>;
  onPassComplete: (result: TResult) => Promise<void>;
}): Promise<TResult[]> {
  const runAndComplete = async (pass: TPass): Promise<TResult> => {
    const result = await runPass(pass);
    await onPassComplete(result);
    return result;
  };

  if (parallel && passes.length > 1) {
    return Promise.all(passes.map(runAndComplete));
  }

  const results: TResult[] = [];
  for (const pass of passes) {
    results.push(await runAndComplete(pass));
  }
  return results;
}
